export interface CatalogPage {
  number: number;
  alt: string;
}

export interface Catalog {
  id: string;
  assetRoot: string;
  title: string;
  titleEn: string;
  eyebrow: string;
  websiteUrl: string;
  width: number;
  height: number;
  highResolutionWidth: number;
  pages: readonly CatalogPage[];
}

const companyPageAlts = [
  "恒良 2024 企业画册封面、公司联系方式与地址地图",
  "恒良公司介绍、生产环境与企业使命",
  "恒良荣誉证书与企业画册目录",
  "一体式自动铝灰处理系统、工艺流程与设备特点",
  "普通铝灰处理系统、工艺流程与设备特点",
  "铝灰机、回转窑、冷灰桶、高速球磨机与高速筛灰机",
  "自动铝棒锯切系统（多棒）功能、设备实景与参数",
  "自动铝棒锯切系统（单棒）功能、设备实景与参数",
  "长棒、短棒自动堆垛与均质炉配套锯切叠垛系统",
  "铝屑收集压块系统与自动针头、激光打码系统",
  "脉冲环保除尘系统、工艺流程与设备实景",
  "恒良铝加工设备配件与精品一览",
  "恒良铝灰处理、铝棒锯切、叠垛与精炼成功案例",
  "恒良国内外合作企业与客户分布",
] as const;

const brochurePageAlts = [
  "恒良 2025 产品折页封面、公司介绍、荣誉证书与战略合作伙伴",
  "熔铸、锯切、均质、叠垛、捆扎、打包与称重生产线全景",
] as const;

const companyCatalog2024: Catalog = {
  id: "hengliang-company-2024",
  assetRoot: "catalog/company-2024/pages",
  title: "恒良 2024 企业画册",
  titleEn: "Hengliang 2024 Company Catalog",
  eyebrow: "2024 COMPANY CATALOG",
  websiteUrl: "http://www.gdfshl.com/",
  width: 2880,
  height: 1955,
  highResolutionWidth: 8640,
  pages: companyPageAlts.map((alt, index) => ({ number: index + 1, alt })),
};

const brochure2025: Catalog = {
  id: "hengliang-brochure-2025",
  assetRoot: "catalog/brochure-2025/pages",
  title: "恒良 2025 产品折页",
  titleEn: "Hengliang 2025 Product Brochure",
  eyebrow: "2025 PRODUCT BROCHURE",
  websiteUrl: "http://www.gdfshl.com/",
  width: 2880,
  height: 1303,
  highResolutionWidth: 8640,
  pages: brochurePageAlts.map((alt, index) => ({ number: index + 1, alt })),
};

export const catalogs: readonly Catalog[] = [companyCatalog2024, brochure2025];
export const defaultCatalog = companyCatalog2024;

export function selectCatalog(
  id: string | null | undefined,
  availableCatalogs: readonly Catalog[] = catalogs,
): Catalog {
  const fallback = availableCatalogs[0];
  if (!fallback) throw new Error("At least one catalog must be configured.");
  return availableCatalogs.find((catalog) => catalog.id === id) ?? fallback;
}

export interface PageAssets {
  small: string;
  large: string;
  high: string;
  srcset: string;
}

export function pageAssets(
  catalog: Catalog,
  page: number,
  base = "/",
): PageAssets {
  const paddedPage = String(page).padStart(2, "0");
  const root = `${base}${catalog.assetRoot}/page-${paddedPage}`;
  const small = `${root}-960.jpg`;
  const large = `${root}-2880.jpg`;
  const high = `${root}-${catalog.highResolutionWidth}.jpg`;

  return {
    small,
    large,
    high,
    srcset: `${small} 960w, ${large} 2880w`,
  };
}
